import { Info, Lock, RefreshCw } from "lucide-react";

export const MAX_SUBMISSIONS = 3;
export const FIRST_NOTICE = "You can vote now and change your vote up to 2 more times (3 submissions total). Only your LAST vote will be counted.";

const Box = ({ tone = "gold", icon: Icon = Info, testId, children }) => (
  <div data-testid={testId} className={`flex gap-3 rounded-2xl border-2 p-4 text-[14px] leading-relaxed ${tone === "green" ? "border-forest/40 bg-forest/10 text-forest" : tone === "red" ? "border-maroon/40 bg-maroon/5 text-maroon" : "border-gold bg-gold/10 text-ink"}`}>
    <Icon className="mt-0.5 h-5 w-5 shrink-0" />
    <div className="min-w-0 flex-1">{children}</div>
  </div>
);

export const ChangesCounter = ({ remaining }) => (
  <span data-testid="changes-remaining-counter" className="inline-flex items-center gap-1.5 rounded-full bg-maroon px-3 py-1 text-xs font-bold text-ivory">
    <RefreshCw className="h-3.5 w-3.5" /> Vote changes remaining: {remaining}
  </span>
);

export const VoteStatusBanner = ({ ballot, onChange }) => {
  if (ballot.count === 0) {
    return (
      <Box testId="first-visit-banner">
        <p className="font-semibold">{FIRST_NOTICE}</p>
        <div className="mt-2"><ChangesCounter remaining={ballot.remaining} /></div>
      </Box>
    );
  }
  if (ballot.remaining === 0) {
    return (
      <Box tone="red" icon={Lock} testId="changes-exhausted-banner">
        <p className="font-semibold">You have used all your vote changes</p>
        <p>The picks below are your final vote.</p>
        <div className="mt-2"><ChangesCounter remaining={0} /></div>
      </Box>
    );
  }
  return (
    <Box tone="green" testId="current-vote-banner">
      <p className="font-semibold">This is your current vote.</p>
      <p>Only your LAST vote will be counted. Visited another puja? You can still change it.</p>
      <div className="mt-2 flex flex-wrap items-center gap-2">
        <ChangesCounter remaining={ballot.remaining} />
        <button type="button" onClick={onChange} data-testid="change-my-vote-btn" className="rounded-full bg-forest px-4 py-1.5 text-xs font-bold text-white">Change my vote</button>
      </div>
    </Box>
  );
};

export const ChangeNotice = ({ ballot }) => {
  if (ballot.count === 0) return <Box testId="review-first-notice"><p className="font-semibold">{FIRST_NOTICE}</p></Box>;
  const left = MAX_SUBMISSIONS - ballot.count - 1;
  return (
    <Box tone="green" icon={RefreshCw} testId="review-change-notice">
      <p className="font-bold">This is change {ballot.count} of 2</p>
      <p>{left} change{left === 1 ? "" : "s"} will remain after this. Your new picks fully replace your previous vote.</p>
    </Box>
  );
};
